
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh"])
      });
    }
  